import React, { useEffect } from 'react';
import { Box, GlobalStyles, ThemeProvider } from '@mui/material';
import { marketingTheme } from '../theme/marketingTheme';
import { marketingColor, marketingGrid } from '../theme/marketingTokens';
import { loadMarketingFonts } from '../theme/loadMarketingFonts';

/**
 * The marketing theme and page ground, without the public site's header and
 * footer chrome.
 *
 * `PublicLayout` covers the marketing pages themselves. This covers the pages
 * a visitor lands on straight out of them — sign in and register — which
 * otherwise stayed on `appTheme` and flashed light grey the moment someone
 * clicked "Get started". They are the last screen of the marketing funnel, not
 * the first screen of the app, so they should look like it.
 *
 * As in `PublicLayout`, a scoped `GlobalStyles` repaints `body` while this is
 * mounted, so overscroll does not reveal the app's light ground underneath.
 */
export const MarketingSurface: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    loadMarketingFonts();
  }, []);

  return (
    <ThemeProvider theme={marketingTheme}>
      <GlobalStyles styles={{ body: { backgroundColor: marketingColor.ink } }} />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: marketingColor.ink,
          backgroundImage: marketingGrid,
          color: marketingColor.text,
          py: 6,
        }}
      >
        {children}
      </Box>
    </ThemeProvider>
  );
};

export default MarketingSurface;
